export interface HighlightedSnippetPart {
  text: string
  match: boolean
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Split a search snippet so query terms can be bolded.
 * Prefers the full query phrase, then individual tokens of length >= 2.
 */
export function highlightQueryInSnippet(
  snippet: string,
  query: string,
): Array<HighlightedSnippetPart> {
  const text = snippet || ''
  const q = query.trim()
  if (!text) {
    return []
  }
  if (!q) {
    return [{ text, match: false }]
  }

  const terms = Array.from(
    new Set(
      [q, ...q.split(/\s+/)].map((term) => term.trim()).filter((term) => term.length >= 2),
    ),
  ).sort((a, b) => b.length - a.length)

  if (terms.length === 0) {
    return [{ text, match: false }]
  }

  const pattern = new RegExp(`(${terms.map(escapeRegExp).join('|')})`, 'gi')
  const parts: Array<HighlightedSnippetPart> = []
  let last = 0
  let match = pattern.exec(text)
  while (match) {
    if (match.index > last) {
      parts.push({ text: text.slice(last, match.index), match: false })
    }
    parts.push({ text: match[0], match: true })
    last = match.index + match[0].length
    if (match[0].length === 0) {
      pattern.lastIndex += 1
    }
    match = pattern.exec(text)
  }
  if (last < text.length) {
    parts.push({ text: text.slice(last), match: false })
  }
  return parts.length > 0 ? parts : [{ text, match: false }]
}
